import { ApplicationConfig, provideZoneChangeDetection, isDevMode, provideAppInitializer, inject, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';
import { authInterceptor } from './interceptors/auth.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { TranslocoHttpLoader } from './transloco-loader';
import { firstValueFrom } from 'rxjs';
import { provideEchartsCore } from 'ngx-echarts';
import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';

import { routes } from './app.routes';

registerLocaleData(localePl);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'pl' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideTransloco({
      config: {
        availableLangs: ['en', 'pl'],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    }),
    provideEchartsCore({ echarts: () => import('echarts') }),
    provideAppInitializer(() => {
      const transloco = inject(TranslocoService);
      return Promise.all([
        firstValueFrom(transloco.load('en')),
        firstValueFrom(transloco.load('pl')),
      ]);
    })
  ]
};
